import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import "./index.css";
import AppRouter from "./routes/AppRouter";
import { PermissionProvider } from "./contexts/ApplicationContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import "react-quill/dist/quill.snow.css";
import 'quill-mention/dist/quill.mention.css';
import "flatpickr/dist/flatpickr.min.css";

const removeLoadingSpinner = () => {
  const loadingContainer = document.getElementById("loading-container");
  if (loadingContainer) {
    loadingContainer.style.display = "none";
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: 300000, //5 minutos para fazer outro refetch
      refetchIntervalInBackground: true,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <PermissionProvider>
      <ThemeProvider>
        <AppRouter />
      </ThemeProvider>
    </PermissionProvider>
  </QueryClientProvider>
);

window.addEventListener("load", removeLoadingSpinner);
